import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'

export const UpsellProjectQuotes = () => {
  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.sales}
      featureRequested={Features.sales_quotes_management}
      requestReason={ValidReasons.MissingAddon}
      requestSource={ProjectsUpsellRequestSources.projectQuotes}
      title={i18n.t('project_management.upselling.title')}
      description={i18n.t('project_management.upselling.quotes')}
      buttonLabel={i18n.t('project_management.upselling.cta')}
      variant="table"
    />
  )
}
